import { render, staticRenderFns } from "./PreviewFaq.vue?vue&type=template&id=fdff0e82&scoped=true"
import script from "./PreviewFaq.vue?vue&type=script&lang=js"
export * from "./PreviewFaq.vue?vue&type=script&lang=js"
import style0 from "./PreviewFaq.vue?vue&type=style&index=0&id=fdff0e82&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdff0e82",
  null
  
)

export default component.exports